import type { Translations } from "./en";

const da: Translations = {
  nav: {
    services: "Ydelser",
    about: "Om mig",
    contact: "Kontakt",
    cta: "Kontakt mig",
  },

  hero: {
    badge: "Cloud- & AI-transformationskonsulent",
    heading: "Din cloud, moderniseret.",
    headingAccent: "Din AI, under kontrol.",
    description:
      "Fra cloud-migrering til Copilot-governance hjælper jeg virksomheder med at udnytte Microsoft 365 sikkert — og gøre AI-agenter til en værdiskabende ressource, ikke et ukontrolleret eksperiment.",
    cta: "Book et scopingmøde",
    statAzure: "Azure & M365",
    statCopilot: "Copilot & Agenter",
    statSecurity: "Sikkerhed & Governance",
    statOkr: "OKR & Strategi",
  },

  services: {
    label: "Ydelser",
    heading: "Certificeret ≠ Sikker. Vi beviser forskellen.",
    subheading: "De fleste organisationer består audits, men fejler under hændelser. Vi validerer det, der faktisk virker — ikke det, der ser godt ud på papir.",
    flagship: {
      badge: "Signaturydelse",
      title: "Compliance Reality Check",
      desc: "En struktureret vurdering, der tester, om dine compliance-kontroller faktisk fungerer under pres — ikke blot om de eksisterer på papir. Vi afdækker gabet mellem audit-artefakter og operationel parathed.",
      cta: "Udforsk Compliance Reality Check",
    },
    items: [
      {
        title: "Cloud-infrastruktur",
        desc: "Azure & Microsoft 365-migrering, arkitektur og operationel hærdning — bygget til virkeligheden, ikke kun referencedesigns.",
      },
      {
        title: "Copilot & AI-governance",
        desc: "Rettighedsaudit, datagrænser, agent-ejerskab og reviderbarhed — fordi Copilot afslører det, der allerede er brudt.",
      },
      {
        title: "Sikkerhed & compliance",
        desc: "Purview, Entra-identitetslivscyklus, insider-risiko og end-to-end sikkerhedspostur — valideret, ikke antaget.",
      },
      {
        title: "Strategi & bestyrelsesrådgivning",
        desc: "OKR-tilpasset rapportering, AI-governance på bestyrelsesniveau og executive advisory — fra dashboards til beslutninger, der betyder noget.",
      },
    ],
  },

  quote: {
    text: "Copilot skaber ikke risiko\u00A0—",
    accent: "den afslører den.",
    body: "De fleste organisationer har allerede for bredt tildelt adgang, fejlkonfigurerede tilladelser og compliance-huller. Copilot gør dem bare synlige. Spørgsmålet er ikke, om man skal bruge AI — men om man er klar til det, den vil afdække.",
  },

  roadmap: {
    label: "AI-køreplan",
    heading: "Hvor Microsoft 365 AI er på vej hen",
    subheading: "Tre faser, der former enterprise-AI — og hvor din organisation bør være.",
    phases: [
      {
        phase: "Fase 1",
        period: "Nu → 2026",
        title: "Copilot som produktivitetslag",
        desc: "Microsoft 365 Copilot bliver det primære interaktionslag for dokumenter, møder, e-mail og søgning — forankret i Microsoft Graph og afgrænset af tilladelser.",
        highlights: ["Kontekstbevidst assistance", "Multi-model AI", "Agent Mode til flertrinsopgaver"],
      },
      {
        phase: "Fase 2",
        period: "2025 → 2027",
        title: "AI-agenter som digitale kolleger",
        desc: "Autonome og semi-autonome agenter der bruger værktøjer, API'er og Graph til at udføre opgaver — fra HR-triagering til bestyrelsespræsentationer.",
        highlights: ["Copilot Studio-agenter", "Deklarative & tilpassede agenter", "Human-in-the-loop-design"],
      },
      {
        phase: "Fase 3",
        period: "2026+",
        title: "Styret AI-driftsmodel",
        desc: "Organisationsomfattende governance for AI-identiteter, datagrænser, reviderbarhed og compliance — så agenter er ansvarlige, ikke ukontrollerede.",
        highlights: ["Agent-identitetslivscyklus", "AI-brugspolitikker", "Rapportering til bestyrelsen"],
      },
    ],
  },

  about: {
    label: "Om mig",
    heading: "Jeg findes, fordi compliance-teater er farligt",
    body: "Jeg har brugt år inde i Microsoft-økosystemer og set organisationer sætte flueben, bestå audits og forblive grundlæggende eksponerede. Certificeringer beviser hensigt. De beviser ikke modstandsdygtighed. EastWest IT er bygget på én overbevisning: den eneste compliance, der tæller, er den, der holder, når noget går galt. Jeg sælger ikke tryghed — jeg validerer, om dine kontroller faktisk virker, din AI faktisk er styret, og din bestyrelse faktisk forstår risikobilledet.",
    highlights: [
      "Certificeret Azure & Microsoft 365-professionel",
      "Mini-MBA i Ledelse",
      "Rådgivnings- og bestyrelsesroller",
      "Resultatdrevet — ikke artefaktdrevet",
    ],
  },

  contact: {
    label: "Kontakt",
    heading: "Lad os afklare dit næste projekt",
    subheading: "Udfyld formularen herunder, så vender jeg tilbage for at planlægge et gratis scopingmøde.",
    nameLabel: "Navn",
    namePlaceholder: "Dit navn",
    companyLabel: "Virksomhed",
    companyPlaceholder: "Din virksomhed",
    emailLabel: "E-mail",
    emailPlaceholder: "dig@virksomhed.dk",
    messageLabel: "Hvordan kan jeg hjælpe?",
    messagePlaceholder: "Fortæl mig om dit projekt eller din udfordring...",
    submit: "Send besked",
    submitting: "Sender...",
    successTitle: "Besked sendt!",
    successDesc: "Tak — jeg vender tilbage hurtigst muligt for at planlægge et scopingmøde.",
    errorTitle: "Noget gik galt",
    errorDesc: "Prøv igen eller send mig en e-mail direkte.",
    emailDirect: "Eller send mig en e-mail direkte",
  },

  footer: {
    rights: "Alle rettigheder forbeholdes.",
  },
};

export default da as Translations;
